var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a87238d5695b5ca6cfa2ba44cf8288bdedadd843"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-headlinker@martinratinaud"]={id:"a87238d5695b5ca6cfa2ba44cf8288bdedadd843"};
      